
import HeaderMenu from './Menu';
import HeaderUserbox from './Userbox';

import {
  Box,
  alpha,
  lighten,
  styled,
  useTheme,
  useMediaQuery
} from '@mui/material';



function Header() {
  const isMobile = useMediaQuery('(max-width:600px)');
  const theme = useTheme();

  const HeaderWrapper = styled(Box)(
    ({ theme }) => `
          height: ${theme.header.height};
          color: ${theme.header.textColor};
          padding: ${theme.spacing(0, 2)};
          right: 0;
          z-index: 6;
          background-color: ${alpha(theme.header.background, 0.95)};
          backdrop-filter: blur(3px);
          position: fixed;
          justify-content: ${isMobile ? 'center' : 'space-between'};
          width: 100%;
          @media (min-width: ${theme.breakpoints.values.lg}px) {
              left: ${theme.sidebar.width};
              width: auto;
          }
  `
  );

  return (
    <HeaderWrapper
      display="flex"
      alignItems="center"
      sx={{
        bottom: isMobile ? 0 : undefined,
        boxShadow:
          theme.palette.mode === 'dark'
            ? `0 1px 0 ${alpha(
              lighten(theme.colors.primary.main, 0.7),
              0.15
            )}, 0px 2px 8px -3px rgba(0, 0, 0, 0.2), 0px 5px 22px -4px rgba(0, 0, 0, .1)`
            : `0px 2px 8px -3px ${alpha(
              theme.colors.alpha.black[100],
              0.2
            )}, 0px 5px 22px -4px ${alpha(
              theme.colors.alpha.black[100],
              0.1
            )}`
      }}
    >
      {isMobile ? (
        <>
          <HeaderMenu />
        </>
      ) : (
        <>
          <Box sx={{ flexShrink: 0, minWidth: 270 }}>
            <Box
              sx={{
                width: 250
              }}
            >
              <img src='/static/images/logo/ckb-fp.png' width={250} style={{ marginLeft: 20 }} />
            </Box>
          </Box>
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              px: 2,
              minWidth: 0,
              maxWidth: '100%'
            }}
          >
            <HeaderMenu />
          </Box>
          <Box display="flex" alignItems="center" sx={{ flexShrink: 0 }}>
            <HeaderUserbox />
          </Box>
        </>
      )}
    </HeaderWrapper>
  );
}

export default Header;
